import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import loadable from '@loadable/component';
import { useLocation } from 'react-router-dom';

import 'assets/css/pages/_filters.scss';
import 'assets/css/pages/_filter-modal.scss';
import { FILTER_TYPES, STATUS, FILTER_TYPES_METADATA } from '../../shared/enums';
import { selectLocalizationData } from '../features/localization/localizationSlice';
import FallbackPlaceholder from '../components/common/FallbackPlaceholder';
import {
  fetchRegionalPrices,
  selectRegionalPricesStatus,
} from '../features/regionalPrices/regionalPricesSlice.js';

const FilterBillboard = loadable(() => import('../components/filter/FilterBillboard'));
const FilterOrder = loadable(() => import('../components/filter/FilterOrder'));
const FilterFeature = loadable(() => import('../components/filter/FilterFeature'));
const FilterDetail = loadable(() => import('../components/filter/FilterDetail'));
const FilterCard = loadable(() => import('../components/filter/FilterCard'));
const Microdata = loadable(() => import('../components/filter/Microdata'));

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const Filter = props => {
  const {
    staticContext,
    match: {
      params: { type },
    },
  } = props;

  const dispatch = useDispatch();
  let localization = useSelector(selectLocalizationData);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get('region');
  if (paramValue === 'US' || paramValue === null) {
    localization = { region: 'US' };
  }
  else {
   localization = { region: 'CA' };
  }
  const status = useSelector(selectRegionalPricesStatus);
  const { PREFETCHED, SUCCEEDED } = STATUS;

  staticContext.bodyClass = 'filter-single';

  const page = Object.keys(FILTER_TYPES)
    .find(key => FILTER_TYPES[key] === type);

  useEffect(() => {
    if (status === STATUS.IDLE) {
      dispatch(fetchRegionalPrices(localization));
    }
    return undefined;
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {FILTER_TYPES_METADATA[page]?.title}
        </title>
        {FILTER_TYPES_METADATA[page]?.description && <meta name='description' content={FILTER_TYPES_METADATA[page]?.description} />}
      </Helmet>
      <div className='filter-single__wrapper' id={`${FILTER_TYPES[page]}-modal`}>
        <FilterBillboard fallback={<FallbackPlaceholder />} page={page} />
        <div className='filter-content'>
          {[ PREFETCHED, SUCCEEDED ].includes(status) && (<FilterOrder page={page} />)}
          <FilterFeature page={page} />
          <FilterDetail page={page} />
          <FilterCard />
        </div>
      </div>
      {[ PREFETCHED, SUCCEEDED ].includes(status) && (<Microdata page={page} />)}
    </>
  );
};

Filter.defaultProps = {
  staticContext: {},
};

export default Filter;
